import React from 'react';
import * as FiIcons from 'react-icons/fi';
import * as BsIcons from 'react-icons/bs';
import { useTheme } from '../contexts/ThemeContext';
import SafeIcon from '../common/SafeIcon';
import { motion } from 'framer-motion';

const { FiSun, FiMoon } = FiIcons;
const { BsCircleHalf } = BsIcons;

function ThemeSwitcher() {
  const { themePreference, changeTheme } = useTheme();

  const buttonVariants = {
    inactive: { scale: 1 },
    active: { scale: 1.15 }
  };

  return (
    <div className="flex items-center bg-gray-100 p-1 rounded-full space-x-1 shadow-sm dark:bg-gray-700">
      <motion.button
        onClick={() => changeTheme('light')}
        className={`p-2 rounded-full transition-colors ${
          themePreference === 'light' 
            ? 'bg-white text-amber-500 shadow-sm dark:bg-gray-600 dark:text-amber-400' 
            : 'text-gray-600 hover:bg-gray-200 dark:text-gray-300 dark:hover:bg-gray-600'
        }`}
        title="Tema claro"
        aria-label="Activar tema claro"
        initial="inactive"
        animate={themePreference === 'light' ? 'active' : 'inactive'}
        variants={buttonVariants}
        whileHover={{ scale: themePreference === 'light' ? 1.15 : 1.1 }}
        whileTap={{ scale: 0.95 }}
      >
        <SafeIcon icon={FiSun} className="w-4 h-4" />
      </motion.button>

      <motion.button
        onClick={() => changeTheme('auto')}
        className={`p-2 rounded-full transition-colors ${
          themePreference === 'auto' 
            ? 'bg-white text-blue-500 shadow-sm dark:bg-gray-600 dark:text-blue-400' 
            : 'text-gray-600 hover:bg-gray-200 dark:text-gray-300 dark:hover:bg-gray-600'
        }`}
        title="Tema automático (basado en la hora)"
        aria-label="Activar tema automático basado en la hora"
        initial="inactive"
        animate={themePreference === 'auto' ? 'active' : 'inactive'}
        variants={buttonVariants}
        whileHover={{ scale: themePreference === 'auto' ? 1.15 : 1.1 }}
        whileTap={{ scale: 0.95 }}
      >
        <SafeIcon icon={BsCircleHalf} className="w-4 h-4" />
      </motion.button>

      <motion.button
        onClick={() => changeTheme('dark')}
        className={`p-2 rounded-full transition-colors ${
          themePreference === 'dark' 
            ? 'bg-white text-indigo-500 shadow-sm dark:bg-gray-600 dark:text-indigo-400' 
            : 'text-gray-600 hover:bg-gray-200 dark:text-gray-300 dark:hover:bg-gray-600'
        }`}
        title="Tema oscuro"
        aria-label="Activar tema oscuro"
        initial="inactive"
        animate={themePreference === 'dark' ? 'active' : 'inactive'}
        variants={buttonVariants}
        whileHover={{ scale: themePreference === 'dark' ? 1.15 : 1.1 }}
        whileTap={{ scale: 0.95 }}
      >
        <SafeIcon icon={FiMoon} className="w-4 h-4" />
      </motion.button>
    </div>
  );
}

export default ThemeSwitcher;